import {
  api_portalOfficeHospitalListing_medicalSubject,
  api_portalOfficeHospitalListing_reportedAdditionalFee,
} from '@/init/swagger';
import { SearchHospitalsType } from '@/schemas/SearchParamsSchemas/app/stations/search/hospitals/Schema';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

type Items = {
  id: number;
  label: string;
  checked: boolean;
};

type Props = {
  hospitalMedicalSubjects: api_portalOfficeHospitalListing_medicalSubject[];
  hospitalReportedAdditionalFees: api_portalOfficeHospitalListing_reportedAdditionalFee[];
  search: () => Promise<void>;
  close: () => void;
};

export const useLogic = ({
  hospitalMedicalSubjects,
  hospitalReportedAdditionalFees,
  search,
  close,
}: Props) => {
  const { getValues, setValue: formSetValue } =
    useFormContext<SearchHospitalsType>();

  const initialItems = hospitalMedicalSubjects.map(({ id, label }) => ({
    id: id ?? NaN,
    label: label ?? '',
    checked: getValues('medical_subjects').find((v) => v === id) != null,
  }));
  const [items, setItems] = useState<Items[]>(initialItems);

  const initialitemsReportedAdditionalFees = hospitalReportedAdditionalFees.map(
    ({ id, label }) => ({
      id: id ?? NaN,
      label: label ?? '',
      checked:
        getValues('reported_additional_fees').find((v) => v === id) != null,
    }),
  );
  const [itemsReportedAdditionalFees, setItemsReportedAdditionalFees] =
    useState<Items[]>(initialitemsReportedAdditionalFees);

  /** チェック状態の切り替えを行う */
  const toggle = (event: React.ChangeEvent<HTMLInputElement>, id: number) => {
    const checked = event.target.checked;
    setItems(
      items.map((item) => (item.id === id ? { ...item, checked } : item)),
    );
  };
  const toggleReportedAdditionalFees = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: number,
  ) => {
    const checked = event.target.checked;
    setItemsReportedAdditionalFees(
      itemsReportedAdditionalFees.map((item) =>
        item.id === id ? { ...item, checked } : item,
      ),
    );
  };

  const onClear = async () => {
    formSetValue('medical_subjects', []);
    formSetValue('reported_additional_fees', []);

    // URLパラメータを更新（共通処理）
    await search();

    close();
  };

  const onSubmit = async () => {
    const checkedIds = items
      .filter((item) => item.checked)
      .map((item) => item.id);
    const checkedIdsReportedAdditionalFees = itemsReportedAdditionalFees
      .filter((item) => item.checked)
      .map((item) => item.id);

    formSetValue('medical_subjects', checkedIds);
    formSetValue('reported_additional_fees', checkedIdsReportedAdditionalFees);

    // URLパラメータを更新（共通処理）
    await search();

    close();
  };

  return {
    items,
    itemsReportedAdditionalFees,
    toggle,
    toggleReportedAdditionalFees,
    onClear,
    onSubmit,
    search,
  };
};
